import { User } from '../core/user';

export default function isUnacknowledgedBypass(bypass) {
  return !bypass.noVerifyReasonType && bypass.username === new User().email;
}
